module.exports = __webpack_public_path__ + "img/app-academy-tutor-5.d2a270c7.jpg";